var guid = Date.now();
export function uniqueId(prefix) {
  if (prefix === void 0) {
    prefix = '';
  }
  return "" + prefix + (guid++).toString(36).toLowerCase();
}